var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-switch',{attrs:{"size":_vm.size,"disabled":_vm.disabled,"checked-children":"是","un-checked-children":"否"},model:{value:(_vm.checkedValue),callback:function ($$v) {_vm.checkedValue=$$v},expression:"checkedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }